import styled from 'styled-components';
import SectionContent from './SectionContent';

const StyledSectionContent = styled(SectionContent)`
  min-height: 100vh;
  
`;

export default StyledSectionContent;